module.exports = __webpack_public_path__ + "static/media/BlogCaldasNovas3.e68a4a90.jpg";